<section class="tw-min-h-screen tw-bg-surface tw-py-12">

  <!-- Banner bienvenida para candidato nuevo -->
  <div *ngIf="esBienvenida"
       class="tw-px-4 tw-max-w-2xl tw-mx-auto tw-mb-6">
    <div class="tw-rounded-2xl tw-p-5 tw-flex tw-items-start tw-gap-4"
         style="background:linear-gradient(135deg,#eff6ff,#f0fdf4);border:1px solid #bfdbfe;">
      <div class="tw-text-3xl tw-shrink-0">🎉</div>
      <div class="tw-flex-1">
        <p class="tw-font-bold tw-text-blue-900 tw-text-base tw-mb-1">¡Bienvenido a TG Empleos!</p>
        <p class="tw-text-sm tw-text-slate-600 tw-mb-3">
          Tu cuenta está lista. Sube tu CV para que la IA encuentre las vacantes más compatibles con tu perfil.
        </p>
        <div class="tw-flex tw-gap-2 tw-flex-wrap">
          <span class="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-bg-green-100 tw-text-green-700 tw-font-medium">✓ Cuenta creada</span>
          <span class="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-bg-amber-100 tw-text-amber-700 tw-font-medium">→ Sube tu CV</span>
          <span class="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-bg-slate-100 tw-text-slate-500 tw-font-medium">○ Activa alertas</span>
        </div>
      </div>
      <button (click)="esBienvenida=false" class="tw-text-slate-400 hover:tw-text-slate-600 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-lg tw-shrink-0">✕</button>
    </div>
  </div>

  <!-- ═══════════════════ CV Management (narrow) ═══════════════════ -->
  <div class="tw-px-4 tw-max-w-2xl tw-mx-auto">

    <!-- Header -->
    <div class="tw-mb-8">
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900">Bóveda de CVs</h1>
      <p class="tw-mt-1 tw-text-slate-500 tw-text-sm">
        {{ isPremium ? 'Sube hasta ' + MAX_CVS + ' currículums' : '1 CV gratis · Premium para guardar hasta 5' }}.
        <span class="tw-font-medium tw-text-brand-600">{{ slotsRestantes }} espacio(s) disponibles.</span>
      </p>
    </div>

    <!-- Alerta sin CV activo -->
    <div *ngIf="!cargando && cvs.length > 0 && !tieneActivoCv"
         class="tw-flex tw-items-start tw-gap-3 tw-px-4 tw-py-3 tw-rounded-xl
                tw-bg-amber-50 tw-border tw-border-amber-300 tw-mb-4">
      <svg class="tw-w-5 tw-h-5 tw-text-amber-500 tw-shrink-0 tw-mt-0.5" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
      </svg>
      <div>
        <p class="tw-text-sm tw-font-semibold tw-text-amber-800">Ningún CV activo</p>
        <p class="tw-text-xs tw-text-amber-700 tw-mt-0.5">
          El GuruMatch y el CV Optimizer no funcionarán hasta que actives uno.
          Haz clic en <strong>Activar</strong> en la tarjeta que quieras usar.
        </p>
      </div>
    </div>

    <!-- Mensajes -->
    <div *ngIf="successMsg"
         class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-rounded-xl
                tw-bg-emerald-50 tw-border tw-border-emerald-200 tw-mb-4">
      <svg class="tw-w-4 tw-h-4 tw-text-emerald-500 tw-shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/>
      </svg>
      <p class="tw-text-sm tw-text-emerald-700 tw-font-medium">{{ successMsg }}</p>
    </div>

    <div *ngIf="errorMsg"
         class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-rounded-xl
                tw-bg-red-50 tw-border tw-border-red-200 tw-mb-4">
      <svg class="tw-w-4 tw-h-4 tw-text-red-500 tw-shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd"/>
      </svg>
      <p class="tw-text-sm tw-text-red-600">{{ errorMsg }}</p>
    </div>

    <!-- Zona de subida -->
    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-shadow-card tw-p-6 tw-mb-6">
      <h2 class="tw-text-base tw-font-semibold tw-text-slate-800 tw-mb-4">Subir nuevo CV</h2>

      <!-- Paywall: free user with 1 CV already -->
      <div *ngIf="!isPremium && cvs.length >= MAX_CVS_FREE"
           class="tw-rounded-xl tw-border tw-border-blue-100 tw-text-center tw-p-8"
           style="background:linear-gradient(135deg,#eff6ff 0%,#f0fdf4 100%)">
        <div class="tw-mx-auto tw-w-12 tw-h-12 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-text-white tw-text-2xl tw-mb-4"
             style="background:linear-gradient(135deg,#3b82f6,#06b6d4)">⚡</div>
        <h3 class="tw-text-base tw-font-semibold tw-text-slate-900 tw-mb-2">Límite del plan gratuito</h3>
        <p class="tw-text-sm tw-text-slate-500 tw-mb-1">El plan gratuito permite guardar <strong>1 CV</strong>.</p>
        <p class="tw-text-sm tw-text-slate-500 tw-mb-5">
          Con <strong>Premium</strong> puedes guardar hasta <strong>5 CVs</strong>, recibir alertas diarias por email y WhatsApp, y más.
        </p>
        <a routerLink="/planes"
           class="tw-inline-block tw-px-6 tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-transition"
           style="background:#1d4ed8">
          ⚡ Activar Premium — ver opciones
        </a>
        <p class="tw-text-xs tw-text-slate-400 tw-mt-3">Elimina el CV actual para reemplazarlo, o activa Premium para guardar más.</p>
      </div>

      <!-- Dropzone: shown when under limit -->
      <ng-container *ngIf="isPremium || cvs.length < MAX_CVS_FREE">

        <div (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave()"
             (drop)="onDrop($event)"
             [class.tw-border-brand-500]="isDragOver"
             [class.tw-bg-brand-50]="isDragOver"
             class="tw-relative tw-border-2 tw-border-dashed tw-border-slate-200 tw-rounded-xl
                    tw-p-8 tw-text-center tw-transition tw-duration-150 tw-cursor-pointer
                    hover:tw-border-brand-400 hover:tw-bg-slate-50/60"
             (click)="fileInput.click()">

          <input #fileInput type="file" accept="application/pdf" class="tw-hidden"
                 (change)="onFileSelect($event)">

          <div *ngIf="!archivoSeleccionado">
            <div class="tw-mx-auto tw-w-12 tw-h-12 tw-rounded-xl tw-bg-brand-50
                        tw-flex tw-items-center tw-justify-center tw-mb-3">
              <svg class="tw-w-6 tw-h-6 tw-text-brand-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
              </svg>
            </div>
            <p class="tw-text-slate-600 tw-font-medium tw-text-sm">
              Arrastra tú CV aquí o <span class="tw-text-brand-600 tw-font-semibold">haz clic para seleccionar</span>
            </p>
            <p class="tw-text-xs tw-text-slate-400 tw-mt-1">Solo PDF · Máximo {{ MAX_SIZE_MB }} MB</p>
          </div>

          <div *ngIf="archivoSeleccionado"
               class="tw-flex tw-items-center tw-gap-3"
               (click)="$event.stopPropagation()">
            <div class="tw-w-10 tw-h-10 tw-rounded-lg tw-bg-red-100 tw-flex tw-items-center tw-justify-center tw-shrink-0">
              <svg class="tw-w-5 tw-h-5 tw-text-red-500" viewBox="0 0 24 24" fill="currentColor">
                <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z"/>
                <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z"/>
              </svg>
            </div>
            <div class="tw-text-left tw-flex-1 tw-min-w-0">
              <p class="tw-text-sm tw-font-medium tw-text-slate-800 tw-truncate">{{ previewName }}</p>
              <p class="tw-text-xs tw-text-slate-400">{{ formatSize(archivoSeleccionado.size) }}</p>
            </div>
            <button (click)="archivoSeleccionado = null; previewName = ''"
                    class="tw-text-slate-400 hover:tw-text-red-500 tw-transition">
              <svg class="tw-w-4 tw-h-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
              </svg>
            </button>
          </div>
        </div>

        <div *ngIf="archivoSeleccionado" class="tw-mt-4 tw-space-y-3">
          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">
              Nombre del CV <span class="tw-text-red-500">*</span>
            </label>
            <input type="text" [(ngModel)]="labelInput" maxlength="100"
                   placeholder='Ej: "CV Java Senior 2025"'
                   class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200
                          tw-text-sm tw-outline-none tw-bg-white
                          focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition">
          </div>
          <button (click)="subirCv()" [disabled]="subiendo"
                  class="tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-brand-600 hover:tw-bg-brand-700
                         tw-text-white tw-font-semibold tw-text-sm tw-transition
                         disabled:tw-opacity-60 disabled:tw-cursor-not-allowed tw-flex tw-items-center tw-justify-center tw-gap-2">
            <svg *ngIf="subiendo" class="tw-w-4 tw-h-4 tw-animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
            </svg>
            {{ subiendo ? 'Subiendo…' : 'Guardar CV' }}
          </button>
        </div>

      </ng-container>
    </div>

    <!-- Lista de CVs -->
    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-shadow-card tw-p-6">
      <h2 class="tw-text-base tw-font-semibold tw-text-slate-800 tw-mb-4">Mis CVs guardados</h2>

      <div *ngIf="cargando" class="tw-space-y-3">
        <div *ngFor="let i of [1,2,3]"
             class="tw-h-16 tw-rounded-xl tw-bg-slate-100 tw-animate-pulse"></div>
      </div>

      <div *ngIf="!cargando && cvs.length === 0"
           class="tw-text-center tw-py-12">
        <div class="tw-mx-auto tw-w-14 tw-h-14 tw-rounded-2xl tw-bg-slate-100
                    tw-flex tw-items-center tw-justify-center tw-mb-3">
          <svg class="tw-w-7 tw-h-7 tw-text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
          </svg>
        </div>
        <p class="tw-text-slate-500 tw-text-sm">Aún no tienes CVs guardados.</p>
        <p class="tw-text-slate-400 tw-text-xs tw-mt-1">Sube tú primer CV para comenzar.</p>
      </div>

      <ul *ngIf="!cargando && cvs.length > 0" class="tw-space-y-2">
        <ng-container *ngFor="let cv of cvs">
        <li class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl tw-border
                   tw-transition tw-duration-150"
            [class.tw-border-brand-200]="cv.isActive"
            [class.tw-bg-brand-50]="cv.isActive"
            [class.tw-border-slate-100]="!cv.isActive"
            [class.tw-bg-white]="!cv.isActive"
            [class.hover:tw-bg-slate-50]="!cv.isActive">

          <div class="tw-w-9 tw-h-9 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-shrink-0"
               [class.tw-bg-brand-100]="cv.isActive"
               [class.tw-bg-red-50]="!cv.isActive">
            <svg class="tw-w-4 tw-h-4" [class.tw-text-brand-600]="cv.isActive" [class.tw-text-red-400]="!cv.isActive"
                 viewBox="0 0 24 24" fill="currentColor">
              <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z"/>
            </svg>
          </div>

          <div class="tw-flex-1 tw-min-w-0">
            <div class="tw-flex tw-items-center tw-gap-2">
              <p class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-truncate">{{ cv.label }}</p>
              <span *ngIf="cv.isActive"
                    class="tw-shrink-0 tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-brand-100
                           tw-text-brand-700 tw-text-xs tw-font-semibold">Activo</span>
            </div>
            <p class="tw-text-xs tw-text-slate-400 tw-truncate tw-mt-0.5">
              {{ cv.fileName }} · {{ formatSize(cv.fileSize) }}
            </p>
          </div>

          <div class="tw-flex tw-items-center tw-gap-1 tw-shrink-0">

            <div *ngIf="!cv.isActive" class="tw-relative tw-group">
              <button (click)="activar(cv)"
                      class="tw-flex tw-items-center tw-gap-1 tw-px-2.5 tw-py-1.5 tw-rounded-lg
                             tw-text-xs tw-font-semibold tw-text-brand-700 tw-bg-brand-50
                             hover:tw-bg-brand-100 tw-border tw-border-brand-200
                             hover:tw-border-brand-400 tw-transition">
                <svg class="tw-w-3.5 tw-h-3.5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                </svg>
                Activar
              </button>
              <span class="tw-pointer-events-none tw-absolute tw-bottom-full tw-left-1/2 -tw-translate-x-1/2
                           tw-mb-1.5 tw-whitespace-nowrap tw-rounded-lg tw-bg-slate-800 tw-px-2.5 tw-py-1
                           tw-text-xs tw-text-white tw-opacity-0 group-hover:tw-opacity-100
                           tw-invisible group-hover:tw-visible tw-transition tw-z-10">
                Usar como CV principal en vacantes
              </span>
            </div>

            <div class="tw-relative tw-group">
              <button (click)="abrir(cv)"
                      class="tw-p-1.5 tw-rounded-lg tw-text-slate-400 hover:tw-text-blue-600
                             hover:tw-bg-blue-50 tw-transition">
                <svg class="tw-w-4 tw-h-4" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"/>
                  <path fill-rule="evenodd" d="M.664 10.59a1.651 1.651 0 010-1.186A10.004 10.004 0 0110 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0110 17c-4.257 0-7.893-2.66-9.336-6.41zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd"/>
                </svg>
              </button>
              <span class="tw-pointer-events-none tw-absolute tw-bottom-full tw-left-1/2 -tw-translate-x-1/2
                           tw-mb-1.5 tw-whitespace-nowrap tw-rounded-lg tw-bg-slate-800 tw-px-2.5 tw-py-1
                           tw-text-xs tw-text-white tw-opacity-0 group-hover:tw-opacity-100
                           tw-invisible group-hover:tw-visible tw-transition tw-z-10">
                Ver PDF en nueva pestaña
              </span>
            </div>

            <div class="tw-relative tw-group">
              <button (click)="descargar(cv)"
                      class="tw-p-1.5 tw-rounded-lg tw-text-slate-400 hover:tw-text-slate-700
                             hover:tw-bg-slate-100 tw-transition">
                <svg class="tw-w-4 tw-h-4" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z"/>
                  <path d="M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z"/>
                </svg>
              </button>
              <span class="tw-pointer-events-none tw-absolute tw-bottom-full tw-left-1/2 -tw-translate-x-1/2
                           tw-mb-1.5 tw-whitespace-nowrap tw-rounded-lg tw-bg-slate-800 tw-px-2.5 tw-py-1
                           tw-text-xs tw-text-white tw-opacity-0 group-hover:tw-opacity-100
                           tw-invisible group-hover:tw-visible tw-transition tw-z-10">
                Descargar PDF
              </span>
            </div>

            <div class="tw-relative tw-group">
              <button (click)="eliminar(cv)"
                      class="tw-p-1.5 tw-rounded-lg tw-text-slate-400 hover:tw-text-red-500
                             hover:tw-bg-red-50 tw-transition">
                <svg class="tw-w-4 tw-h-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z" clip-rule="evenodd"/>
                </svg>
              </button>
              <span class="tw-pointer-events-none tw-absolute tw-bottom-full tw-left-1/2 -tw-translate-x-1/2
                           tw-mb-1.5 tw-whitespace-nowrap tw-rounded-lg tw-bg-slate-800 tw-px-2.5 tw-py-1
                           tw-text-xs tw-text-white tw-opacity-0 group-hover:tw-opacity-100
                           tw-invisible group-hover:tw-visible tw-transition tw-z-10">
                Eliminar CV
              </span>
            </div>

            <div class="tw-relative tw-group">
              <button (click)="optimizarCv(cv)"
                      [disabled]="optimizerLoadingCv.has(cv.id)"
                      class="tw-p-1.5 tw-rounded-lg tw-text-slate-400 hover:tw-text-sky-600
                             hover:tw-bg-sky-50 tw-transition disabled:tw-opacity-50">
                <svg *ngIf="optimizerLoadingCv.has(cv.id)" class="tw-w-4 tw-h-4 tw-animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                  <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                </svg>
                <span *ngIf="!optimizerLoadingCv.has(cv.id)" style="font-size:16px">✨</span>
              </button>
              <span class="tw-pointer-events-none tw-absolute tw-bottom-full tw-right-0
                           tw-mb-1.5 tw-whitespace-nowrap tw-rounded-lg tw-bg-slate-800 tw-px-2.5 tw-py-1
                           tw-text-xs tw-text-white tw-opacity-0 group-hover:tw-opacity-100
                           tw-invisible group-hover:tw-visible tw-transition tw-z-10">
                Optimizar CV con IA
              </span>
            </div>

          </div>
        </li>

        <!-- CV Optimizer result panel (per CV) -->
        <ng-container *ngIf="getOptimizerResult(cv.id) as opt">

          <!-- Limit CTA — mensaje diferente segun plan -->
          <div *ngIf="opt.limitado"
               class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-px-4 tw-py-3 tw-rounded-xl tw-mb-2 tw-mt-1"
               [class.tw-bg-amber-50]="!isPremium" [class.tw-border-amber-200]="!isPremium"
               [class.tw-bg-blue-50]="isPremium" [class.tw-border-blue-200]="isPremium"
               style="border-width:1px;border-style:solid;">
            <span class="tw-text-sm tw-font-medium"
                  [class.tw-text-amber-800]="!isPremium" [class.tw-text-blue-800]="isPremium">
              {{ isPremium ? 'Has alcanzado tu análisis diario del CV Optimizer. Vuelve mañana.' : 'Has alcanzado tu límite mensual del CV Optimizer.' }}
            </span>
            <a *ngIf="!isPremium" routerLink="/planes"
               class="tw-shrink-0 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-white tw-text-xs tw-font-semibold tw-transition"
               style="background:#1d4ed8;text-decoration:none">
              ⚡ Ver planes Premium
            </a>
          </div>

          <!-- Optimizer result -->
          <div *ngIf="!opt.limitado"
               class="tw-mt-1 tw-mb-2 tw-rounded-xl tw-border tw-border-sky-200 tw-bg-sky-50 tw-p-4">

            <p class="tw-text-xs tw-font-semibold tw-text-sky-700 tw-mb-3">
              Análisis de <strong>{{ cv.label }}</strong>
            </p>

            <!-- Scores row -->
            <div class="tw-flex tw-gap-8 tw-mb-3">
              <div *ngIf="opt.matchScore !== undefined">
                <p class="tw-text-xs tw-font-semibold tw-text-sky-700 tw-uppercase tw-tracking-wide tw-mb-1">Match CV</p>
                <p class="tw-text-2xl tw-font-bold tw-leading-none" [style.color]="scoreColor(opt.matchScore)">
                  {{ opt.matchScore }}%
                </p>
              </div>
              <div>
                <p class="tw-text-xs tw-font-semibold tw-text-sky-700 tw-uppercase tw-tracking-wide tw-mb-1">ATS Score</p>
                <p class="tw-text-2xl tw-font-bold tw-leading-none tw-text-sky-900">{{ opt.atsScore }}%</p>
              </div>
            </div>

            <!-- FREE view: keywords completas + primera recomendacion -->
            <ng-container *ngIf="!opt.isPremium">
              <!-- Todas las keywords faltantes -->
              <div *ngIf="opt.missingKeywords?.length" class="tw-mb-3">
                <p class="tw-text-xs tw-font-semibold tw-text-sky-700 tw-mb-1.5">Keywords faltantes en tu CV</p>
                <div class="tw-flex tw-flex-wrap tw-gap-1.5">
                  <span *ngFor="let kw of opt.missingKeywords"
                        class="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-md tw-bg-sky-200 tw-text-sky-800 tw-font-medium">
                    {{ kw }}
                  </span>
                </div>
              </div>

              <!-- Primera recomendacion -->
              <div *ngIf="opt.recommendations?.length" class="tw-mb-3">
                <p class="tw-text-xs tw-font-semibold tw-text-sky-700 tw-mb-1.5">Sugerencia principal</p>
                <div class="tw-px-3 tw-py-2.5 tw-rounded-lg tw-bg-white tw-border tw-border-sky-100">
                  <p class="tw-text-xs tw-font-semibold tw-text-sky-800 tw-mb-0.5">{{ opt.recommendations[0].section }}</p>
                  <p class="tw-text-xs tw-text-slate-600 tw-leading-relaxed">{{ opt.recommendations[0].suggestion }}</p>
                </div>
              </div>

              <!-- CTA para análisis completo (fortalezas + puntuación por sección + resto de recomendaciones) -->
              <div *ngIf="(opt.recommendations?.length || 0) > 1 || opt.strengths?.length || opt.sectionFeedback?.length"
                   class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-px-4 tw-py-3 tw-rounded-xl tw-mt-2"
                   style="background:#f0f9ff;border:1px solid #bae6fd;">
                <p class="tw-text-xs tw-text-sky-700 tw-font-medium">
                  ⚡ Análisis completo: fortalezas, puntuación por sección y {{ (opt.recommendations?.length || 1) - 1 }} sugerencias más
                </p>
                <a routerLink="/planes"
                   class="tw-shrink-0 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-white tw-text-xs tw-font-semibold"
                   style="background:linear-gradient(135deg,#1e3a5f,#1d4ed8);text-decoration:none;">
                  Premium →
                </a>
              </div>
            </ng-container>

            <!-- PREMIUM view: full analysis -->
            <ng-container *ngIf="opt.isPremium">
              <!-- All missing keywords -->
              <div *ngIf="opt.missingKeywords?.length" class="tw-mb-4">
                <p class="tw-text-xs tw-font-semibold tw-text-sky-700 tw-mb-1.5">Keywords faltantes</p>
                <div class="tw-flex tw-flex-wrap tw-gap-1.5">
                  <span *ngFor="let kw of opt.missingKeywords"
                        class="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-md tw-bg-sky-200 tw-text-sky-800 tw-font-medium">
                    {{ kw }}
                  </span>
                </div>
              </div>

              <!-- Strengths -->
              <div *ngIf="opt.strengths?.length" class="tw-mb-4">
                <p class="tw-text-xs tw-font-semibold tw-text-emerald-700 tw-mb-2">✓ Fortalezas de tu perfil</p>
                <div class="tw-space-y-1.5">
                  <div *ngFor="let s of opt.strengths"
                       class="tw-flex tw-items-start tw-gap-2 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-emerald-50 tw-border tw-border-emerald-100">
                    <svg class="tw-w-3.5 tw-h-3.5 tw-text-emerald-500 tw-shrink-0 tw-mt-0.5" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/>
                    </svg>
                    <p class="tw-text-xs tw-text-emerald-800 tw-leading-relaxed">{{ s }}</p>
                  </div>
                </div>
              </div>

              <!-- Section feedback grid -->
              <div *ngIf="opt.sectionFeedback?.length" class="tw-mb-4">
                <p class="tw-text-xs tw-font-semibold tw-text-sky-700 tw-mb-2">Puntuación por sección</p>
                <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                  <div *ngFor="let sf of opt.sectionFeedback"
                       class="tw-bg-white tw-rounded-lg tw-p-3 tw-border tw-border-sky-100">
                    <div class="tw-flex tw-items-center tw-justify-between tw-mb-1">
                      <p class="tw-text-xs tw-font-semibold tw-text-sky-800">{{ sf.section }}</p>
                      <p class="tw-text-base tw-font-bold tw-leading-none" [style.color]="scoreColor(sf.score)">{{ sf.score }}%</p>
                    </div>
                    <p class="tw-text-xs tw-text-slate-500 tw-leading-relaxed">{{ sf.comment }}</p>
                  </div>
                </div>
              </div>

              <!-- Full recommendations -->
              <div *ngIf="opt.recommendations?.length">
                <p class="tw-text-xs tw-font-semibold tw-text-sky-700 tw-mb-2">Sugerencias de mejora</p>
                <div *ngFor="let r of opt.recommendations"
                     class="tw-mb-2 tw-px-3 tw-py-2.5 tw-rounded-lg tw-bg-white tw-border tw-border-sky-100">
                  <p class="tw-text-xs tw-font-semibold tw-text-sky-800 tw-mb-0.5">{{ r.section }}</p>
                  <p class="tw-text-xs tw-text-slate-600 tw-leading-relaxed">{{ r.suggestion }}</p>
                </div>
              </div>
            </ng-container>

          </div>
        </ng-container>
        </ng-container>
      </ul>
    </div>

    <!-- CTA: Activar Alertas — solo si aún no tiene canal configurado -->
    <div *ngIf="!alertasActivas"
         class="tw-mt-5 tw-rounded-2xl tw-p-5 tw-text-center tw-border"
         style="background:linear-gradient(135deg,#eff6ff 0%,#f0fdf4 100%);border-color:#bfdbfe">
      <div class="tw-text-2xl tw-mb-2">🔔</div>
      <h3 class="tw-text-sm tw-font-semibold tw-text-slate-900 tw-mb-1">Activa alertas de vacantes</h3>
      <p class="tw-text-xs tw-text-slate-500 tw-mb-4">
        La IA analiza tu CV activo y te avisa cuando haya una vacante con +70% de compatibilidad.
      </p>
      <a routerLink="/mis-alertas"
         class="tw-inline-block tw-px-5 tw-py-2 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm"
         style="background:#1d4ed8">
        Activar alertas →
      </a>
    </div>

  </div>

  <!-- ═══════════════════ Vacantes acorde a tu perfil (wider) ═══════════════════ -->
  <div class="tw-px-4 tw-max-w-4xl tw-mx-auto tw-mt-12 tw-pb-16">

    <!-- Section header -->
    <div class="tw-flex tw-items-start tw-justify-between tw-mb-4 tw-gap-4">
      <div>
        <div class="tw-flex tw-items-center tw-gap-2.5 tw-mb-1">
          <div class="tw-w-8 tw-h-8 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-shrink-0"
               style="background:linear-gradient(135deg,#1e3a5f,#1d4ed8)">
            <svg class="tw-w-4 tw-h-4 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"/>
            </svg>
          </div>
          <h2 class="tw-text-xl tw-font-extrabold tw-text-slate-900">Vacantes Inteligentes</h2>
          <span class="tw-text-xs tw-font-bold tw-px-2 tw-py-0.5 tw-rounded-full tw-tracking-wide"
                style="background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;">IA</span>
        </div>
        <p class="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-max-w-lg">
          Conecta con empleos recomendados automáticamente por GuruMatch — la IA analiza tu CV y encuentra las vacantes más compatibles con tu perfil.
        </p>
      </div>
      <span *ngIf="guruMatchEjecutado && matchedVacantes.length > 0"
            class="tw-text-xs tw-font-semibold tw-px-3 tw-py-1.5 tw-rounded-full tw-shrink-0 tw-whitespace-nowrap tw-mt-1"
            style="background:#dcfce7;color:#16a34a;border:1px solid #bbf7d0;">
        {{ matchedVacantes.length }} match{{ matchedVacantes.length !== 1 ? 'es' : '' }} encontrado{{ matchedVacantes.length !== 1 ? 's' : '' }}
      </span>
    </div>

    <!-- GuruMatch global button -->
    <div *ngIf="candidatoId" class="tw-flex tw-items-center tw-gap-3 tw-mt-4 tw-mb-2">
      <div class="tw-relative tw-group tw-flex-1">
        <button (click)="ejecutarGuruMatch()"
                [disabled]="guruMatchLoading || !tieneActivoCv"
                class="tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-5 tw-py-2.5
                       tw-rounded-xl tw-font-semibold tw-text-sm tw-transition tw-border-0 tw-cursor-pointer
                       disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                style="background:linear-gradient(135deg,#1e3a5f,#1d4ed8);color:#fff">
          <svg *ngIf="guruMatchLoading" class="tw-w-4 tw-h-4 tw-animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
          </svg>
          <svg *ngIf="!guruMatchLoading" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"/>
          </svg>
          {{ guruMatchLoading ? 'Analizando tu CV…' : (!tieneActivoCv ? '📄 Sube tu CV para activar GuruMatch' : (guruMatchEjecutado ? 'Volver a analizar' : 'GuruMatch — encontrar mis vacantes')) }}
        </button>
        <span class="tw-pointer-events-none tw-absolute tw-bottom-full tw-left-1/2 -tw-translate-x-1/2
                     tw-mb-2 tw-whitespace-nowrap tw-rounded-lg tw-bg-slate-800 tw-px-3 tw-py-1.5
                     tw-text-xs tw-text-white tw-opacity-0 group-hover:tw-opacity-100
                     tw-invisible group-hover:tw-visible tw-transition tw-z-10">
          Encontrar mis mejores matches de trabajo
        </span>
      </div>
      <span *ngIf="!isPremium && guruMatchUsosRestantes !== null"
            class="tw-text-xs tw-text-slate-400 tw-shrink-0">
        {{ guruMatchUsosRestantes > 0 ? guruMatchUsosRestantes + ' uso(s) restante(s) este mes' : 'Límite usado · renueva el ' + guruMatchFechaRenovacion }}
      </span>
    </div>

    <!-- Limit CTA GuruMatch — mensaje diferente segun plan -->
    <div *ngIf="guruMatchLimitado"
         class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-px-4 tw-py-3 tw-rounded-xl tw-mb-4 tw-mt-2"
         [class.tw-bg-amber-50]="!isPremium" [class.tw-border-amber-200]="!isPremium"
         [class.tw-bg-blue-50]="isPremium" [class.tw-border-blue-200]="isPremium"
         style="border-width:1px;border-style:solid;">
      <span class="tw-text-sm tw-font-medium"
            [class.tw-text-amber-800]="!isPremium" [class.tw-text-blue-800]="isPremium">
        {{ isPremium ? 'Has alcanzado tu GuruMatch diario. Vuelve mañana para un nuevo análisis.' : 'Has usado tu GuruMatch mensual gratuito.' }}
      </span>
      <a *ngIf="!isPremium" routerLink="/planes"
         class="tw-shrink-0 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-white tw-text-xs tw-font-semibold tw-transition"
         style="background:#1d4ed8;text-decoration:none">
        ⚡ Ver planes Premium
      </a>
    </div>

    <!-- Skeleton while loading history on init -->
    <div *ngIf="historyLoading" class="tw-space-y-4 tw-mt-4">
      <div *ngFor="let i of [1,2,3]"
           class="tw-h-28 tw-rounded-2xl tw-bg-slate-100 tw-animate-pulse"></div>
    </div>

    <!-- Skeleton while GuruMatch is running -->
    <div *ngIf="guruMatchLoading" class="tw-space-y-4 tw-mt-4">
      <div *ngFor="let i of [1,2,3]"
           class="tw-h-28 tw-rounded-2xl tw-bg-slate-100 tw-animate-pulse"></div>
    </div>

    <!-- Estado inicial: aún no ejecutó GuruMatch y no hay historial -->
    <div *ngIf="!historyLoading && !guruMatchLoading && !guruMatchEjecutado"
         class="tw-mt-4 tw-rounded-2xl tw-overflow-hidden"
         style="background:linear-gradient(135deg,#0f172a 0%,#1e3a5f 60%,#1d4ed8 100%);">
      <div class="tw-px-8 tw-py-10 tw-text-center">
        <div class="tw-mx-auto tw-w-16 tw-h-16 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-mb-5"
             style="background:rgba(255,255,255,0.12);">
          <svg class="tw-w-8 tw-h-8 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"/>
          </svg>
        </div>
        <h3 class="tw-text-white tw-font-bold tw-text-lg tw-mb-2">Tu motor de empleos inteligente</h3>
        <p class="tw-text-blue-200 tw-text-sm tw-max-w-sm tw-mx-auto tw-leading-relaxed tw-mb-6">
          GuruMatch analiza tu CV con IA, extrae tus habilidades y encuentra las vacantes con mayor compatibilidad en segundos.
        </p>
        <div class="tw-flex tw-justify-center tw-gap-6 tw-mb-6">
          <div class="tw-text-center">
            <div class="tw-text-white tw-font-extrabold tw-text-2xl">+70%</div>
            <div class="tw-text-blue-300 tw-text-xs tw-mt-0.5">compatibilidad mínima</div>
          </div>
          <div class="tw-w-px tw-bg-white/20"></div>
          <div class="tw-text-center">
            <div class="tw-text-white tw-font-extrabold tw-text-2xl">IA</div>
            <div class="tw-text-blue-300 tw-text-xs tw-mt-0.5">análisis real de CV</div>
          </div>
          <div class="tw-w-px tw-bg-white/20"></div>
          <div class="tw-text-center">
            <div class="tw-text-white tw-font-extrabold tw-text-2xl">{{ tieneActivoCv ? '✓' : '—' }}</div>
            <div class="tw-text-blue-300 tw-text-xs tw-mt-0.5">{{ tieneActivoCv ? 'CV listo' : 'Sube tu CV' }}</div>
          </div>
        </div>
        <p class="tw-text-blue-300 tw-text-xs tw-italic">Usa el botón GuruMatch de arriba para comenzar →</p>
      </div>
    </div>

    <!-- GuruMatch results -->
    <ng-container *ngIf="!historyLoading && !guruMatchLoading && guruMatchEjecutado">

      <!-- Results header with timestamp -->
      <div class="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-2.5
                  tw-rounded-xl tw-bg-blue-50 tw-border tw-border-blue-200 tw-mb-4 tw-mt-2">
        <span class="tw-text-sm tw-text-blue-800 tw-font-semibold">
          {{ matchedVacantes.length }} vacante(s) con alta compatibilidad
        </span>
        <span *ngIf="guruMatchAt" class="tw-text-xs tw-text-blue-500">· Analizado el {{ guruMatchAt }}</span>
      </div>

      <!-- No matches -->
      <div *ngIf="matchedVacantes.length === 0"
           class="tw-text-center tw-py-16 tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100">
        <p class="tw-text-slate-500 tw-text-sm tw-font-medium">No encontramos vacantes con alta compatibilidad</p>
        <p class="tw-text-slate-400 tw-text-xs tw-mt-1">
          El umbral mínimo puede estar configurado muy alto, o aún no hay vacantes que encajen con tu perfil exacto.
        </p>
      </div>

      <!-- Visible job cards (all for premium, first 3 for free) -->
      <div class="tw-space-y-4">
        <div *ngFor="let job of visibleVacantes"
             class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-shadow-card tw-p-5">

          <div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
            <div class="tw-flex-1 tw-min-w-0">
              <h3 class="tw-text-base tw-font-semibold tw-text-slate-900 tw-leading-snug tw-mb-2">
                {{ job.titulo }}
              </h3>
              <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-1.5 tw-mb-2">
                <span *ngIf="job.empresa" class="tw-text-xs tw-text-slate-600 tw-font-medium">{{ job.empresa }}</span>
                <span *ngIf="job.ubicacion" class="tw-text-xs tw-text-slate-400">· {{ job.ubicacion }}</span>
                <span class="tw-text-xs tw-font-semibold tw-px-2 tw-py-0.5 tw-rounded-full"
                      [class.tw-bg-green-100]="job.modalidad === 'REMOTO'"
                      [class.tw-text-green-700]="job.modalidad === 'REMOTO'"
                      [class.tw-bg-amber-100]="job.modalidad === 'HIBRIDO'"
                      [class.tw-text-amber-700]="job.modalidad === 'HIBRIDO'"
                      [class.tw-bg-slate-100]="job.modalidad === 'PRESENCIAL'"
                      [class.tw-text-slate-600]="job.modalidad === 'PRESENCIAL'">
                  {{ job.modalidad }}
                </span>
                <span *ngIf="job.categoriaNombre"
                      class="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-slate-100 tw-text-slate-500">
                  {{ job.categoriaNombre }}
                </span>
                <span *ngIf="getScore(job.id) !== null"
                      class="tw-px-2.5 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-bold tw-border"
                      [style.background]="scoreColor(getScore(job.id) || 0) + '18'"
                      [style.color]="scoreColor(getScore(job.id) || 0)"
                      [style.borderColor]="scoreColor(getScore(job.id) || 0) + '40'">
                  {{ getScore(job.id) }}% match
                </span>
                <span *ngIf="job.fechaPublicacion" class="tw-text-xs tw-text-slate-400">
                  · Publicada {{ job.fechaPublicacion | appDate:'dd/MM/yyyy' }}
                </span>
              </div>
              <div *ngIf="job.tecnologias?.length" class="tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2">
                <span *ngFor="let t of job.tecnologias | slice:0:8"
                      class="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-md tw-bg-slate-100 tw-text-slate-600 tw-font-medium">
                  {{ t }}
                </span>
              </div>
              <div *ngIf="getJustification(job.id)"
                   class="tw-flex tw-items-start tw-gap-1.5 tw-mt-2 tw-px-3 tw-py-2
                          tw-rounded-lg tw-bg-blue-50 tw-border tw-border-blue-100">
                <svg class="tw-w-3.5 tw-h-3.5 tw-text-blue-500 tw-shrink-0 tw-mt-0.5" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/>
                </svg>
                <p class="tw-text-xs tw-text-blue-700 tw-leading-relaxed">{{ getJustification(job.id) }}</p>
              </div>
              <div *ngIf="getSuggestion(job.id)"
                   class="tw-flex tw-items-start tw-gap-1.5 tw-mt-2 tw-px-3 tw-py-2
                          tw-rounded-lg tw-bg-amber-50 tw-border tw-border-amber-100">
                <svg class="tw-w-3.5 tw-h-3.5 tw-text-amber-500 tw-shrink-0 tw-mt-0.5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 1a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5A.75.75 0 0110 1zM5.05 3.636a.75.75 0 011.06 0l1.062 1.06A.75.75 0 116.11 5.757l-1.06-1.06a.75.75 0 010-1.06zm9.9 0a.75.75 0 010 1.06l-1.06 1.06a.75.75 0 01-1.062-1.061l1.061-1.06a.75.75 0 011.06 0zM3 10a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5A.75.75 0 013 10zm11 0a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5A.75.75 0 0114 10zm-6.94 4.94a.75.75 0 010 1.06l-1.062 1.06a.75.75 0 01-1.06-1.06l1.06-1.06a.75.75 0 011.062 0zm5.88 0a.75.75 0 011.06 0l1.062 1.06a.75.75 0 11-1.061 1.061l-1.06-1.06a.75.75 0 010-1.06zM10 15a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5A.75.75 0 0110 15z"/>
                </svg>
                <p class="tw-text-xs tw-text-amber-700 tw-leading-relaxed"><span class="tw-font-semibold">Mejora tu CV:</span> {{ getSuggestion(job.id) }}</p>
              </div>
            </div>
            <div class="tw-flex tw-flex-col tw-items-stretch tw-gap-2 tw-shrink-0" style="min-width:130px;">
              <!-- Si tiene página interna (vacante scrapeada guardada en MySQL): ir a detalles -->
              <a *ngIf="job.urlVacante; else externalLink"
                 [routerLink]="['/vacantes/detalles', job.urlVacante]"
                 [state]="{ scrapedJobId: job.id, urlOriginal: job.urlOriginal }"
                 class="tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-px-3 tw-py-1.5 tw-rounded-lg
                        tw-bg-brand-600 hover:tw-bg-brand-700 tw-text-white tw-text-xs tw-font-semibold tw-transition">
                Ver vacante
              </a>
              <!-- Sin página interna: abrir fuente original en nueva pestaña -->
              <ng-template #externalLink>
                <a *ngIf="job.urlOriginal" [href]="job.urlOriginal" target="_blank" rel="noopener"
                   class="tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-px-3 tw-py-1.5 tw-rounded-lg
                          tw-bg-brand-600 hover:tw-bg-brand-700 tw-text-white tw-text-xs tw-font-semibold tw-transition">
                  Ver vacante
                  <svg class="tw-w-3 tw-h-3" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"/>
                    <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"/>
                  </svg>
                </a>
              </ng-template>
            </div>
          </div>

        </div>
      </div>

      <!-- Blurred cards + Premium CTA (FREE users only, when there are hidden results) -->
      <div *ngIf="blurredVacantes.length > 0" class="tw-relative tw-mt-4">

        <!-- Blurred preview cards -->
        <div class="tw-space-y-4 tw-pointer-events-none tw-select-none"
             style="filter:blur(5px);opacity:.45;max-height:340px;overflow:hidden;">
          <div *ngFor="let job of blurredVacantes | slice:0:4"
               class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-shadow-card tw-p-5">
            <div class="tw-flex tw-items-start tw-gap-4">
              <div class="tw-flex-1 tw-min-w-0">
                <h3 class="tw-text-base tw-font-semibold tw-text-slate-900 tw-mb-2">{{ job.titulo }}</h3>
                <div class="tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2">
                  <span *ngIf="job.empresa" class="tw-text-xs tw-text-slate-600 tw-font-medium">{{ job.empresa }}</span>
                  <span *ngIf="getScore(job.id) !== null"
                        class="tw-px-2.5 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-bold tw-border"
                        [style.background]="scoreColor(getScore(job.id) || 0) + '18'"
                        [style.color]="scoreColor(getScore(job.id) || 0)"
                        [style.borderColor]="scoreColor(getScore(job.id) || 0) + '40'">
                    {{ getScore(job.id) }}% match
                  </span>
                </div>
                <div *ngIf="getJustification(job.id)"
                     class="tw-flex tw-items-start tw-gap-1.5 tw-mt-2 tw-px-3 tw-py-2
                            tw-rounded-lg tw-bg-blue-50 tw-border tw-border-blue-100">
                  <p class="tw-text-xs tw-text-blue-700">{{ getJustification(job.id) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Gradient overlay -->
        <div class="tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-48"
             style="background:linear-gradient(to top,rgba(248,250,252,1) 0%,rgba(248,250,252,.7) 60%,transparent 100%);"></div>

        <!-- Premium CTA overlay -->
        <div class="tw-absolute tw-inset-x-0 tw-bottom-0 tw-flex tw-flex-col tw-items-center tw-pb-6 tw-pt-4">
          <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-amber-200 tw-shadow-lg tw-px-6 tw-py-5 tw-text-center tw-max-w-sm tw-w-full">
            <div class="tw-text-2xl tw-mb-2">⚡</div>
            <p class="tw-text-sm tw-font-bold tw-text-slate-900 tw-mb-1">
              {{ blurredVacantes.length }} vacante(s) más te esperan
            </p>
            <p class="tw-text-xs tw-text-slate-500 tw-mb-4">
              Con Premium ves todos tus matches y ejecutas GuruMatch una vez al día.
            </p>
            <a routerLink="/planes"
               class="tw-inline-block tw-px-6 tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-transition"
               style="background:linear-gradient(135deg,#1e3a5f,#1d4ed8);text-decoration:none;">
              Ver planes Premium →
            </a>
          </div>
        </div>

      </div>

    </ng-container>

  </div>

</section>
